/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class ReportProcessModel {
        private logType: string = "ReportProcessModel";

        public process: warsApp.models.ProcessDto;
        public processConfiguration: Wars.Domain.Model.ProcessConfiguration;
        public visibleForms: Wars.Domain.Model.Form[];
        public currentForm: Wars.Domain.Model.Form;
        public formData: any;
        public currentFormDataId: string;
        public parentForm: Wars.Domain.Model.Form;

        public showUserActionConfirmation: boolean;
        public userActionDto: Wars.Domain.Model.Dtos.Workflow.UserActionDto;

        constructor(
            private $location: angular.ILocationService,
            private $rootScope: angular.IRootScopeService,
            private $filter: angular.IFilterService,
            private localStorageService: any,
            public processTypeId: string,
            public processId: string,
            private processTypeService: services.ProcessTypeService,
            private processService: services.ProcessService,
            private cacheConfigurationService: services.ConfigurationCacheService,
            private modalService: any,
            private formDataService: services.FormDataService,
            private signalRService: services.SignalrService,
            private growl: angular.growl.IGrowlService,
            private conditionService: services.ConditionService,
            private userService: services.UserService,
            private objectQueryService: services.ObjectQueryService,
            private scope: any,
            private formId?: string,
            private formDataId?: string,
            public parentFormId?: string,
            public parentFormDataId?: string,
            public parentFormName?: string) {

            if (this.processId) {
                var self = this;

                this.processService.getProcessDto(this.processId)
                    .then(process => {
                        this.process = process;

                        this.cacheConfigurationService
                            .getVersionedProcessConfiguration(this.process.processConfigurationId)
                            .then(config => {
                                self.processConfiguration = config;

                                if (self.formId) {
                                    self.visibleForms = Enumerable.from(config.myForms)
                                        .where(form => form.id === self.formId)
                                        .toArray();
                                } else {
                                    self.visibleForms = Enumerable.from(config.myForms)
                                        .where(form => process.formsVisibilities[form.uniqueIdentifier] &&
                                            !process.formsVisibilities[form.uniqueIdentifier].onlyVisibleAsChild)
                                        .toArray();
                                }

                                if (self.visibleForms.length > 0) {
                                    if (formDataId) {
                                        this.currentFormDataId = formDataId;
                                    } else {
                                        self.setCurrentFormDataId(self.visibleForms[0]);
                                    }
                                    self.currentForm = self.visibleForms[0];

                                    if ((<any>self).groupSettings == null) {
                                        self.objectQueryService.getGroupSettings(self.process.processConfigurationId, self.currentForm.uniqueIdentifier)
                                            .then((results) => {
                                                if (results != null) {
                                                    (<any>self).groupSettings = results;
                                                }
                                            });    
                                    }

                                    

                                }
                            });
                    });

                let currentUser = this.userService.getCurrentUser();
                this.signalRService.listen(scope).then((listener) => {
                    listener.onSignalGroupOfProcessDataUpdate((user, result) => {
                        //console.log(result);
                        if (result.type === "FieldUpdate") {
                            if (currentUser.userName !== user) {
                                this.processService.processFormUpdateResults(this.process, result.updatedFields, this.conditionService);
                            }
                        }
                    });
                });
            } else {
                this.processService.createNewProcess(processTypeId).then(
                    (createProcessDto: Wars.Domain.Model.Dtos.CreateProcessDto) => {
                        this.redirectAfterProcessCreation(processTypeId, createProcessDto.processId);
                    });
            }

            //re-constitute previous results for the report if they exist 
            //var groupSettings = localStorage.getItem(`reportGroupSettings-${this.processId}`);
            //if (groupSettings != null) {
            //    (<any>this).groupSettings = JSON.parse(groupSettings);    
            //}
            //var results = localStorage.getItem('reportResults');
            //if (results != null) {
            //    var parsed = JSON.parse(results);
            //    if (parsed.reportProcessId === this.processId) {
            //        var now = new Date();
            //        var expire = new Date(parsed.date);
            //        expire.setHours(expire.getHours() + 1);
            //        if (expire.getTime() > now.getTime()) {
            //            (<any>this).objectQueryResults = JSON.parse(parsed.data);
            //            if ((<any>this).objectQueryResults.isGrouped) {
            //                localStorage.removeItem('reportResultsSort');
            //            } else {
            //                if ((<any>this).objectQueryResults.rows != undefined && (<any>this).objectQueryResults.rows.length > 0) {
            //                    var sorted = localStorage.getItem('reportResultsSort');
            //                    if (sorted != null) {
            //                        this.sorted = JSON.parse(sorted);
            //                        this.sort(this.sorted.value, true);
            //                    } else {
            //                        this.sorted.value = (<any>this).objectQueryResults.sortId;
            //                    }
            //                    var currentPage = localStorage.getItem('reportResultsPage');
            //                    if (currentPage != null) {
            //                        var p = parseInt(currentPage); 
            //                        if (p !== NaN && p <= this.getTotalPages()) {
            //                            this.paging.currentPage = p;
            //                        }
            //                    }
            //                }
            //            }    
            //        }
            //    }
            //}
            //
        }

        private redirectAfterProcessCreation(processTypeId: string, processId: string): void {
            this.processId = processId;
            var path = '/ProcessType/' + processTypeId + '/ReportProcess/' + this.processId;
            services.WarsLogger.logDebug("Create new process path: " + path, this.logType);
            this.$location.path(path);
        }

        private setCurrentFormDataId(form: Wars.Domain.Model.Form) {
            if (!this.process.formJson) {
                this.process.formJson = <any>{};
            }

            

            //TODO: make this work with multi-instance forms
            if (this.process.formJson[form.uniqueIdentifier] && Enumerable.from(this.processConfiguration.myForms).any(f => f.maxInstances === 1 && f.uniqueIdentifier === form.uniqueIdentifier)) {
                this.currentFormDataId = Object.keys(this.process.formJson[form.uniqueIdentifier])[0];
            }
            else if (this.process.formJson[form.uniqueIdentifier]) {
                this.currentFormDataId = Object.keys(this.process.formJson[form.uniqueIdentifier])[0];
            }
            else {
                this.currentFormDataId = null;
                this.formDataService.createFormData(this.process.id, form.uniqueIdentifier)
                    .then(formDataId => {
                        this.currentFormDataId = formDataId;
                    });
            }
        }

        reorderGroup(setting: services.ObjectQueryGroupSetting, up: boolean) {
            var self = this;
            var settings = (<any>self).groupSettings;
            if (setting.order === 1 && up) return;
            if (setting.order === settings.length && !up) return;
            if (up) {
                var sd = Enumerable.from(settings).first(i => (<any>i).order === setting.order - 1);
                setting.order -= 1;
                (<any>sd).order += 1;
            }
            if (!up) {
                var su = Enumerable.from(settings).first(i => (<any>i).order === setting.order + 1);
                setting.order += 1;
                (<any>su).order -= 1;
            }
            //preserve group settings so results can be grouped based on last usage 
            //localStorage.setItem(`reportGroupSettings-${self.processId}`, JSON.stringify((<any>self).groupSettings, null, "\t"));
        }
        sorted = {
            value: "",
            ascending: true
        }

        sort(val, override: boolean) {
            var self = this;
            if (self.sorted.value === val) {
                if (!override) {
                    self.sorted.ascending = !self.sorted.ascending;    
                }
            } else {
                self.sorted.value = val;
                self.sorted.ascending = true;
            }
            if ((<any>self).objectQueryResults.rows != undefined && (<any>self).objectQueryResults.rows.length > 0) {
                if ((<any>self).objectQueryResults.rows[0].sortId !== val) {
                    (<any>self).objectQueryResults.sortId = val;
                    for (var i = 0; i < (<any>self).objectQueryResults.rows.length; i++) {
                        var m = Enumerable.from((<any>self).objectQueryResults.rows[i].cells).where(x => (<any>x).id === val).firstOrDefault();
                        if (m != null) {
                            (<any>self).objectQueryResults.rows[i].sortKey = m.value;    
                        }
                    }
                }
            }
            //preserve sort so results can be re-sorted after location change 
            //localStorage.setItem('reportResultsSort', JSON.stringify(self.sorted, null, "\t"));
        }

        filter() {
            var self = this;
            var columns = Enumerable.from((<any>self).objectQueryResults.columns).where(x => (<any>x).ngFilter !== undefined && (<any>x).ngFilter.trim() !== "").toArray();
            (<any>self).objectQueryResults.rows = (<any>self).allRows;
            for (var i = 0; i < columns.length; i++) {
                
                (<any>self).objectQueryResults.rows = self.$filter('filter')((<any>self).objectQueryResults.rows, (r) => {
                    var columnIndex = (<any>columns[i]).order - 1;
                    var filterVal = (<any>columns[i]).ngFilter.toUpperCase();
                    return r.cells[columnIndex].value && r.cells[columnIndex].value.toString().toUpperCase().indexOf(filterVal) !== -1;
                });    
            }
        }

        expandAll() {
            var self = this;
            if ((<any>self).objectQueryResults.rows != undefined && (<any>self).objectQueryResults.rows.length > 0) {
                var rows = (<any>self).objectQueryResults.rows;
                for (var i = 0; i < rows.length; i++) {
                    rows[i].expanded = true;
                }
            }
        }

        collapseAll() {
            var self = this;
            if ((<any>self).objectQueryResults.rows != undefined && (<any>self).objectQueryResults.rows.length > 0) {
                var rows = (<any>self).objectQueryResults.rows;
                for (var i = 0; i < rows.length; i++) {
                    rows[i].expanded = undefined;
                }
            }
        }

        paging = {
            currentPage: 1,
            pageSize: 100,
            goToPage: 1
        }

        getTotalPages() {
            var self = this;
            if ((<any>self).objectQueryResults == null) return 0;
            var rows = (<any>self).objectQueryResults.rows;
            if (rows == null) return 0;
            return rows.length > 0 ? Math.ceil(rows.length / self.paging.pageSize) : 1;
        }

        setCurrentPage() {
            var self = this;
            if (self.paging.goToPage > 0 && self.paging.goToPage <= self.getTotalPages()) {
                self.paging.currentPage = self.paging.goToPage;
            }
            //localStorage.setItem('reportResultsPage', self.paging.currentPage.toString());
        }

        setGoToPage() {
            var self = this;
            self.paging.goToPage = self.paging.currentPage;
            //localStorage.setItem('reportResultsPage', self.paging.currentPage.toString());
        }

        public submit() {
            var self = this;
            //localStorage.removeItem('reportResultsSort');
            //localStorage.removeItem('reportResultsPage');
            //localStorage.removeItem('reportResults');
            self.sorted.ascending = true;
            (<any>this).objectQueryResults = null;
            self.objectQueryService.executeForm(self.processTypeId,
                    self.currentForm.uniqueIdentifier,
                    self.processId,
                    (<any>self).groupSettings)
                .then((results) => {
                if (results != null) {
                    var resultsCompressed = results.isCompressed;
                    var exceedsMaxResults = results.exceedsMaxAllowedResults;
                    results = results.payload;
                    var parsed: any;
                    if (resultsCompressed) {
                        // Decode base64 (convert ascii to binary)
                        var strData = atob(results);
                        // Convert binary string to character-number array
                        var charData = strData.split("").map((x) => { return x.charCodeAt(0); });
                        // Turn number array into byte-array
                        var binData = new Uint8Array(charData);
                        // Pako magic
                        var data = pako.inflate(binData);
                        // convert to unsigned 16 bit
                        var arr = new Uint16Array(data);
                        // Convert gunzipped byteArray back to ascii string:
                        var json = [];
                        var objectEndFound = false;
                        var objectDeserialized = 0;
                        //process in reverse to remove the variable byte order markers at the front of the byte array
                        for (var i = arr.length - 1; i > 0; i--) {
                            var char = String.fromCharCode(arr[i]);
                            if (char === "}") {
                                objectDeserialized += 1;
                            }
                            if (char === "{") {
                                objectDeserialized -= 1;
                            }
                            if (objectDeserialized === 0 && !objectEndFound) continue;
                            json.push(char);
                            objectEndFound = true;
                            if (objectDeserialized === 0) break;
                        }
                        //reverse the array and parse the object
                        json = json.reverse();
                        parsed = JSON.parse(json.join(""));
                    } else {
                        parsed = JSON.parse(results);
                    }
                    var now = new Date();
                    var runtime = now;
                    //var runtime = (now.getMonth() + 1) +
                    //    "/" +
                    //    now.getDate() +
                    //    "/" +
                    //    now.getFullYear() +
                    //    " @ " +
                    //    ((now.getHours() < 10) ? "0" : "") +
                    //    ((now.getHours() > 12) ? (now.getHours() - 12) : now.getHours()) +
                    //    ":" +
                    //    ((now.getMinutes() < 10) ? "0" : "") +
                    //    now.getMinutes() +
                    //    ":" +
                    //    ((now.getSeconds() < 10) ? "0" : "") +
                    //    now.getSeconds() +
                    //    ((now.getHours() > 12) ? ("PM") : "AM");

                    parsed.runtime = runtime;
                    //preserve results so they can be re-constituted after location change 
                    var reportResults = {
                        data: JSON.stringify(parsed, null, "\t"),
                        reportProcessId: self.processId,
                        date: new Date()
                    }
                    if (exceedsMaxResults) {
                        self.growl.info("The query result limit was exceeded so the results below are partial.");
                    }
                    //cache results
                    //try {
                    //    localStorage.setItem('reportResults', JSON.stringify(reportResults, null, "\t"));
                    //} catch (e) {
                    //    self.growl.info("Results cannot be cached based on the number of records returned.");
                    //}
                    //if (reportResults.data.length > 20000) {
                    //    self.growl.info("Results cannot be cached based on the number of records returned.");
                    //} else {
                    //    localStorage.setItem('reportResults', JSON.stringify(reportResults, null, "\t"));    
                    //}
                    //
                    (<any>self).objectQueryResults = parsed;
                    if ((<any>self).objectQueryResults.rows != undefined &&
                        (<any>self).objectQueryResults.rows.length > 0) {
                        self.sorted.value = (<any>self).objectQueryResults.sortId;
                    }

                    (<any>self).allRows = Enumerable.from((<any>self).objectQueryResults.rows).toArray();
                }
            });
        }

        public clear() {
            var self = this;
            self.formDataService.clearFormData(self.processId, self.currentForm.uniqueIdentifier, self.currentFormDataId).then(r => {
                for (let propName in self.process.formJson[self.currentForm.uniqueIdentifier][self.currentFormDataId]) {
                    self.process.formJson[self.currentForm.uniqueIdentifier][self.currentFormDataId][propName] = null;
                }
                //added the reload of the process DTO to resync the form state in case an unmapped field is used
                //to control field displays via display conditions - for example: "show advanced options"
                self.processService.getProcessDto(self.processId)
                    .then((process) => {
                        self.process = process;
                    });
            });
            //localStorage.removeItem('reportResultsSort');
            //localStorage.removeItem(`reportGroupSettings-${this.processId}`);
            //localStorage.removeItem('reportResultsPage');
            //localStorage.removeItem('reportResults');
            (<any>self).objectQueryResults = null;
            self.$rootScope.$broadcast('userPickerCleared');
        }

        public changeForm(form: Wars.Domain.Model.Form) {
            this.currentForm = form;
            this.setCurrentFormDataId(form);
        }
    }
}